<script>
  import { onMount } from 'svelte';
  import { browser } from '$app/environment';
  import { env } from '$env/dynamic/public';
  import { analyticsStore } from '$lib/analytics/store';
  import { getUserContext } from '$lib/user/context';
  import { setAnonUserIdIfConsented } from '$lib/analytics/cookies';
  import GoogleAnalytics from './GoogleAnalytics.svelte';
  import DatadogRum from './DatadogRum.svelte';

  onMount(() => {
    if (!browser) {
      return;
    }

    setAnonUserIdIfConsented();

    const { analytics } = getUserContext();
    if (env.PUBLIC_ENVIRONMENT !== 'production') {
      return;
    }

    analyticsStore.init(analytics);
  });
</script>

<GoogleAnalytics />
<DatadogRum />
